import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=6f28a9f5&"
import script from "./Instagram.vue?vue&type=script&lang=ts&"
export * from "./Instagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports